import React from 'react'
import complete from '../../../../assests/images/complete.jpg'
import {  Typography } from '@material-ui/core'

const CompletedPage = ({isMobileView}) => {

    return (
        <div className="booking_boxes">
            <div
                style={{
                    display: 'flex',
                    gap: 10,
                    alignItems: 'center',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                <Typography className="step-headers">Thank you for booking with us!</Typography>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <img src={complete} alt="" className="completedImage" />
                </div>
                <Typography className="step-subheadersNew">
                    We look forward to seeing you at your appointment
                </Typography>
                <Typography className="step-sub-headers" style={{textAlign:'center'}}>
                    If you have any questions or need to make an adjustments to your appointment please TEXT us at {' '}
                    <span style={{fontWeight: '550' }}>(855) 446-8628</span>
                </Typography>
            </div>
        </div>
    )
}

export default CompletedPage
